<template>
  <div class="container_content" id="nodeS1">
    <!-- 底图 -->
    <img src="@/common/images/nodeService/dfhj_bg1.png" class="dfhj_bg1" />
    <!-- content -->
    <div class="dfhj1_content">
      <img src="@/common/images/nodeService/dfhj_bgl1.png" class="content_left" @click="showMap()" />
      <img src="@/common/images/nodeService/dfhj_c1.png" class="content_right" />
      <img src="@/common/images/nodeService/dot.png" class="dot_right" />
      <img src="@/common/images/nodeService/map.png" class="map1" v-show="showit" />
      <div class="content" v-html="content">
      </div>
    </div>

  </div>
</template>

<script>
  export default {
    data() {
      return {
        content: "山东点服环境科技有限公司（简称：点服环境科技），是一家致力于环卫信息化建设与服务、环卫行业相关智能终端产品的研发、设计、生产、销售等为一体的高新技术企业。同时，全面开展智慧环卫、垃圾分类、农村改厕管护等相关环境领域的市场化运营业务，打造以智慧科技为主的现代化技术及运营服务。\n依托丰富的行业资源，公司紧抓机遇，纵深发展。公司是国内最早“智慧环卫整体解决方案”的制定者和实施者，运营有目前国内最早的“环卫云”服务平台：平台服务政府部门、环卫企业等用户超50余家，平台管理车辆超过1万辆，平台管理人员规模超15万人等；创新推出“互联网+回收”的业务平台及相关硬件产品和运营服务，成为国内最早从智慧环卫延伸到智能垃圾分类领域的环卫技术企业；创新率先研发“农村改厕智能管护平台”解决方案，并一直领先国内行业；领先推出农村改厕“管护+运营服务+智能化”于一体的市场化运作模式，成为发起者和实施者，并在多个地市成功运营了相关项目。",
        showit: true
      }
    },
    mounted() {
      let reg = new RegExp("\n", "g");
      let str = this.content.replace(reg, "<br>");
      this.content = str;
    },
    methods: {
      showMap() {
        this.showit = !this.showit
      }
    }
  }
</script>

<style>
  .container_content{
    position: relative;
    margin-top: -88px;
  }
  .dfhj_bg1 {
    width: 1920px;
    height: 1147px;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 0;
  }

  .dfhj1_content {
    width: 1920px;
    height: 1047px;
    position: relative;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }

  .content_left {
    width: 631px;
    height: 482px;
    position: absolute;
    left: 200px;
    top: 300px;
    animation-name: bounceInLeft;
    animation-duration: 2s;
  }

  .content_right {
    width: 770px;
    height: 854px;
    position: absolute;
    right: 260px;
    top: 60px;
    animation-name: fadeInRight;
    animation-duration: 2s;
  }

  .dot_right {
    width: 207px;
    height: 232px;
    position: absolute;
    right: 220px;
    top: 80px;
    animation-name: bounceInRight;
    animation-duration: 4s;
    animation-delay: -1s;
  }

  .content {
    width: 618px;
    height: 700px;
    position: absolute;
    right: 325px;
    top: 160px;
    word-wrap: normal;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 10;
    /* overflow: hidden; */
    /* text-overflow: ellipsis; */
    line-height: 2.2rem;
    animation-name: zoomIn;
    animation-duration: 3s;
    /* text-indent: 20px; */
    /* letter-spacing: 1px; */
  }

  .flipInX {
    animation-name: bounce;
    animation-duration: 1s;
    animation-iteration-count: 100;
  }

  .map1 {
    width: 56px;
    height: 61px;
    position: absolute;
    left: 520px;
    top: 448px;
    z-index: 10;
    animation-name: bounceInDown;
    animation-duration: 2s;
  }
</style>



// WEBPACK FOOTER //
// src/components/nodeS1.vue